import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ProductDetailReducer } from '@grandvisionhq/fun-products';
import { getVariantInfo } from '../../helpers.js';
import { useProductLink } from '../../utils/use-product-link.js';

const ProductDetailContext = /*#__PURE__*/ React.createContext({});
const useProductDetailContext = ()=>React.useContext(ProductDetailContext)
;
var ProductDetailProvider = (_param)=>{
    var { children , product , locale , sku , productType , selfUrl , bookAppointmentRouteConfig  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "product",
        "locale",
        "sku",
        "productType",
        "selfUrl",
        "bookAppointmentRouteConfig"
    ]);
    const [state, dispatch] = React.useReducer(ProductDetailReducer.productDetailContextReducer, swcHelpers.objectSpread({}, ProductDetailReducer.initialState, {
        activeSku: sku
    }));
    const activeVariant = React.useMemo(()=>getVariantInfo(product, productType, locale, state.activeSku)
    , [
        locale,
        product,
        productType,
        state.activeSku
    ]);
    const productUrl = `${selfUrl}${useProductLink(product.slug, activeVariant.sku, productType)}`;
    const value = swcHelpers.objectSpread({
        activeSku: state.activeSku,
        activeVariant,
        dispatch,
        product,
        productType,
        productUrl,
        bookAppointmentRouteConfig
    }, rest);
    return /*#__PURE__*/ React.createElement(ProductDetailContext.Provider, {
        value: value
    }, children);
};

export { ProductDetailContext, ProductDetailProvider, useProductDetailContext };
//# sourceMappingURL=ProductDetailContext.js.map
